import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import { SelectField } from "@/components/ui/form/fields/select-field";

import { useReservationLocalPaymentCancelFeeTransferInfo } from "./hooks/use-local-payment-cancel-fee-transfer-info";

import type { TransferInfo } from "./type";

type FormField = {
	type: "text" | "select";
	label: string;
	placeholder?: string;
	field: keyof TransferInfo;
};

const FORM_FIELDS: FormField[] = [
	{
		type: "text",
		label: "銀行名",
		placeholder: "例）チルン銀行",
		field: "bankName",
	},
	{
		type: "text",
		label: "支店名",
		placeholder: "例）一号支店",
		field: "branchName",
	},
	{
		type: "select",
		label: "口座種類",
		field: "bankAccountType",
	},
	{
		type: "text",
		label: "口座番号（7桁未満の場合は頭に0をつけてください）",
		placeholder: "例）1234567",
		field: "bankAccountNumber",
	},
	{
		type: "text",
		label: "口座名義（カナ）",
		placeholder: "例）チルンタロウ",
		field: "bankAccountHolderName",
	},
];

export const QuestionReservationLocalPaymentCancelFeeTransferInfo = () => {
	const {
		isEdited,
		hasError,
		localPaymentCancelFeeTransferInfo,
		onSetBankAccountHolderName,
		onSetBankAccountNumber,
		onSetBankAccountType,
		onSetBankName,
		onSetBranchName,
		bankAccountTypeOptions,
	} = useReservationLocalPaymentCancelFeeTransferInfo();

	const title = "キャンセル料金の送金先口座";
	const guide = "現地決済のお客様がキャンセル料金を振り込む口座情報を登録してください。";

	const handleFieldChange = (field: keyof TransferInfo) => (value: string) => {
		switch (field) {
			case "bankName":
				onSetBankName(value);
				break;
			case "branchName":
				onSetBranchName(value);
				break;
			case "bankAccountType":
				onSetBankAccountType(value);
				break;
			case "bankAccountNumber":
				onSetBankAccountNumber(value);
				break;
			case "bankAccountHolderName":
				onSetBankAccountHolderName(value);
				break;
		}
	};

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<QuestionSectionWrapper>
					<div className="flex flex-col gap-y-6">
						{FORM_FIELDS.map(({ type, label, placeholder, field }) => {
							const fieldData = localPaymentCancelFeeTransferInfo?.[field];

							if (type === "select") {
								return (
									<SelectField
										key={field}
										label={label}
										value={fieldData?.value ?? ""}
										options={bankAccountTypeOptions}
										handleValueChange={handleFieldChange(field)}
										errorMessage={fieldData?.error}
									/>
								);
							}

							return (
								<InputTextField
									key={field}
									label={label}
									placeholder={placeholder}
									value={fieldData?.value ?? null}
									handleChange={handleFieldChange(field)}
									errorMessage={fieldData?.error}
								/>
							);
						})}
					</div>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionReservationLocalPaymentCancelFeeTransferInfo.displayName =
	"QuestionReservationLocalPaymentCancelFeeTransferInfo";
